import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface ExportAudienceDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  exportUrl: string;
}

export default function ExportAudienceDialog({
  isOpen,
  onOpenChange,
  exportUrl,
}: ExportAudienceDialogProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <Component open={isOpen} onOpenChange={onOpenChange}>
      <Content className="lg:w-[448px]">
        <Title>Your export is ready</Title>
        <Description className="mb-8">
          Click the button below to download your export in CSV format
        </Description>

        <Button
          className="ml-auto"
          onClick={() => {
            window.open(exportUrl);
            onOpenChange(false);
          }}
        >
          Download
        </Button>
      </Content>
    </Component>
  );
}
